import { posthog } from './analytics';
const DEVICE_STORE = 'deviceAuthStore';
const READ_WRITE = 'readwrite';
const KEY_PAIR = 'keyPair';
const DEBUG = false;
// NOTE: sublecrypto does not work on HTTP (only HTTPS) unless localhost
// which means it does not work for local mobile device testing
function log(msg) {
    if (DEBUG)
        console.log(msg);
}
export function hex(buffer) {
    let digest = '';
    const view = new DataView(buffer);
    for (let i = 0; i < view.byteLength; i += 4) {
        // We use getUint32 to reduce the number of iterations (notice the `i += 4`)
        const value = view.getUint32(i);
        // toString(16) will transform the integer into the corresponding hex string
        // but will remove any initial "0"
        const stringValue = value.toString(16);
        // One Uint32 element is 4 bytes or 8 hex chars (it would also work with 4
        // chars for Uint16 and 2 chars for Uint8)
        const padding = '00000000';
        const paddedValue = (padding + stringValue).slice(-padding.length);
        digest += paddedValue;
    }
    return digest;
}
export function toBase64(buffer) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)));
}
export function sha256(str) {
    // Get the string as arraybuffer.
    const buffer = new TextEncoder().encode(str);
    return crypto.subtle.digest('SHA-256', buffer).then(function (hash) {
        return hex(hash);
    });
}
export function sha256ToBase64(str) {
    // Get the string as arraybuffer.
    const buffer = new TextEncoder().encode(str);
    return crypto.subtle.digest('SHA-256', buffer).then(function (hash) {
        return toBase64(hash);
    });
}
async function initStoredKeyPair() {
    log(`initStoredKeyPair`);
    let keyPair = await getStoredKeyPair();
    if (!keyPair) {
        log(`generating new keypair`);
        const newKeyPair = await genKeyPair();
        if (!newKeyPair)
            return undefined;
        log(`putting new keypair`);
        await putStoredKeyPair(newKeyPair);
        keyPair = await getStoredKeyPair();
        log(`got newly stored keypair`);
    }
    else {
        log(`got previously stored keypair`);
    }
    // if (keyPair) {
    // 	try {
    // 		const pubKey = await window.crypto.subtle.exportKey('jwk', keyPair.publicKey);
    // 		log(`pubKey: ${JSON.stringify(pubKey)}`);
    // 	} catch (e) {
    // 		console.log(`exportKey error`);
    // 	}
    // }
    return keyPair;
}
export async function getStoredKeyPair() {
    if (typeof window === 'undefined')
        return undefined;
    return new Promise((resolve, reject) => {
        try {
            const open = window.indexedDB.open(DEVICE_STORE, 1);
            open.onupgradeneeded = function () {
                try {
                    const db = open.result;
                    db.createObjectStore(DEVICE_STORE, { keyPath: 'id' });
                }
                catch (err) {
                    console.log(`indexDb::createObjectStore exception: ${err}`);
                    posthog.capture(`indexDb::createObjectStore exception`, { error: err });
                    reject(err);
                }
            };
            open.onsuccess = function () {
                const db = open.result;
                const tx = db.transaction(DEVICE_STORE, READ_WRITE);
                const store = tx.objectStore(DEVICE_STORE);
                const req = store.get(KEY_PAIR);
                req.onsuccess = function () {
                    try {
                        db.close();
                        if (req && req.result && req.result.keyPair)
                            resolve(req.result.keyPair);
                        else
                            resolve(undefined);
                    }
                    catch (err) {
                        console.log(`getStoredKeyPair error: ${err}`);
                        posthog.capture(`getStoredKeyPair error`, { error: err });
                        reject(err);
                    }
                };
            };
        }
        catch (err) {
            console.log(`getStoredKeyPair error: ${err}`);
            posthog.capture(`getStoredKeyPair error`, { error: err });
            reject(err);
        }
    });
}
export async function getStoredPublicKey() {
    const keyPair = await getStoredKeyPair();
    if (keyPair) {
        try {
            return toBase64(await window.crypto.subtle.exportKey('spki', keyPair.publicKey));
        }
        catch (e) {
            console.log(`exportKey error`);
        }
    }
    return undefined;
}
async function genKeyPair() {
    try {
        const keyPair = await window.crypto.subtle.generateKey({
            name: 'ECDSA',
            namedCurve: 'P-384'
        }, false, ['sign', 'verify']);
        return keyPair;
    }
    catch (err) {
        console.log(`genKeyPair error`);
    }
    return undefined;
}
async function putStoredKeyPair(keyPair) {
    log(`putStoredKeyPair`);
    return new Promise((resolve, reject) => {
        try {
            log(`put key`);
            const open = window.indexedDB.open(DEVICE_STORE, 1);
            open.onupgradeneeded = function () {
                try {
                    const db = open.result;
                    db.createObjectStore(DEVICE_STORE, { keyPath: 'id' });
                }
                catch (err) {
                    console.log(`indexDb::createObjectStore exception: ${err}`);
                    posthog.capture(`indexDb::createObjectStore exception`, { error: err });
                    reject(err);
                }
            };
            open.onsuccess = function () {
                try {
                    const db = open.result;
                    const tx = db.transaction(DEVICE_STORE, READ_WRITE);
                    const store = tx.objectStore(DEVICE_STORE);
                    store.put({ id: KEY_PAIR, keyPair });
                    tx.oncomplete = function () {
                        try {
                            db.close();
                            log(`keyPair stored`);
                            resolve(true);
                        }
                        catch (err) {
                            console.log(`putStoredKeypair error: ${err}`);
                            posthog.capture(`putStoredKeyPair error`, { error: err });
                            reject(err);
                        }
                    };
                }
                catch (err) {
                    console.log(`putStoredKeypair error: ${err}`);
                    posthog.capture(`putStoredKeyPair error`, { error: err });
                    reject(err);
                }
            };
        }
        catch (err) {
            reject(err);
        }
    });
}
initStoredKeyPair()
    .then((keyPair) => {
    if (keyPair)
        log(`keyPair acquired`);
    else
        log(`keyPair not found`);
})
    .catch((err) => {
    console.log(`initStoredKeyPair error: ${err}`);
});
